import React from 'react';

import Button from 'react-scale/components/ui/button';

const CTAS = ({ theme, ctas, themeColors, size }) => (
  <div className="flex flex-wrap justify-center w-full gap-6 lg:justify-start sm:w-auto">
    {ctas.map(cta => (
      <div key={cta.text} className="w-full sm:w-auto">
        <Button
          theme={theme}
          text={cta.text}
          variant={cta.variant}
          size={cta.size || size}
          href={cta.href}
          borderColor={cta.borderColor}
          themeColors={themeColors}
          fullWidth
        />{' '}
      </div>
    ))}
  </div>
);

CTAS.defaultProps = {
  theme: 'dark',
  ctas: [
    {
      text: 'Get Started',
      href: '/rapid',
      variant: 'primary'
    },
    {
      text: 'Talk To Sales',
      href: '/sales',
      variant: 'secondary'
    }
  ]
};

export default CTAS;
